import { Box } from '@chakra-ui/react'

import theme from 'theme'

import type { BoxProps } from '@chakra-ui/react'

type Props = {
  type?: 'vertical' | 'horizontal'
  size: number | string
} & Omit<BoxProps, 'background' | 'backgroundColor' | 'bg' | 'bgColor' | 'width' | 'height' | 'w' | 'h'>

const Separator = ({ type = 'vertical', size, ...props }: Props) => {
  const sepSize = typeof size === 'string' ? size : `${size}px`

  return (
    <Box
      h={type === 'horizontal' ? '1px' : sepSize}
      w={type === 'horizontal' ? sepSize : '1px'}
      background={theme.colors.gray['200']}
      {...props}
    />
  )
}

export default Separator
